module.exports = __webpack_public_path__ + "img/plane-arrival.fea65673.svg";